import * as React from "react";
import { addBranch } from "services/branchService";
import { toast } from "react-toastify";
import { Button } from "@progress/kendo-react-buttons";
import BranchesList from "./brancheslist";
import styles from "../Settings.module.scss";
import EditBranch from "./Editbranch";

const Branches = (props) => {
  const [showAddNewBranchForm, setShowAddNewBranchForm] = React.useState(false);
  const [isSubmitting, setIsSubmitting] = React.useState(false);

  const closeform = () => {
    setShowAddNewBranchForm(false);
  };

  React.useEffect(() => {
    if (props.onClose === false) {
      closeform();
    }
  }, [props.onClose]);

  const handleSubmitNewBranch = async (e) => {
    setIsSubmitting(true);
    try {
      const result = await addBranch(e);
      if (result.success) {
        toast.success("Branch Added Successfully");
        setShowAddNewBranchForm(false);
      }
    } catch (error) {
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="d-flex flex-column h-100 w-100 settings-container">
      <div className="d-flex justify-content-end mb-3 flex-shrink-0">
        <Button
          className={`common-btn setting-btn`}
          onClick={() => {
            setShowAddNewBranchForm(true);
            props.open();
          }}
        >
          Add Branch
        </Button>
      </div>

      <div className="flex-grow-1  mb-2" style={{ minHeight: 0 }}>
        <BranchesList />
      </div>

      {showAddNewBranchForm && (
        <EditBranch
          cancelEdit={closeform}
          onSubmit={handleSubmitNewBranch}
          type="addNew"
          isSubmitting={isSubmitting}
        />
      )}
    </div>
  );
};

export default Branches;
